<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header text-center">
        <h4>REPORTE DEUDAS</h4>
        <form
          action=""
          [formGroup]="buscarForm"
          (ngSubmit)="ListarExistencia()"
          class="form-horizontal form-material noprint"
          id="categoryform"
          novalidate
        >
          <button onclick="window.print();return false;">
            <i class="fa fa-print"></i>
          </button>

          <div class="row">
            <div class="col-md-5">
              <label for="inputGroupSelect02">Vendedor</label>
              <select
                class="custom-select"
                id="inputGroupSelect02"
                formControlName="vendedor"
              >
                <option value="">Todos</option>
                <option *ngFor="let vendedor of users" [ngValue]="vendedor.id">
                  {{ vendedor.nombres }} {{ vendedor.apellidos }}</option
                >
              </select>
            </div>
            <div class="col-md-5">
              <label for="inputGroupSelect02">Cliente</label>
              <select
                class="custom-select"
                id="inputGroupSelect02"
                formControlName="cliente"
              >
                <option value="">Todos</option>
                <option
                  *ngFor="let cliente of clientes"
                  [ngValue]="cliente.cliente_id"
                >
                  {{ cliente.nombres }} {{ cliente.apellidos }}</option
                >
              </select>
            </div>
            <div class="col-md-2">
              <button
                class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                [disabled]="buscarForm.invalid || isLoading"
              >
                <app-button-loader
                  [isLoading]="isLoading"
                  [label]="'Buscar'"
                ></app-button-loader>
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="card-body">
        <table
          class="table table-bordered table-striped table-condensed  table-responsive-md"
        >
          <thead>
            <tr>
              <th>#. Pedido</th>
              <th>Fecha</th>
              <th>Cliente</th>
              <th>Vendedor</th>
              <th>Total Venta</th>
              <th>Pagado</th>
              <th>Deuda</th>
            </tr>
          </thead>
          <tbody *ngFor="let data of existencia; let i = index">
            <tr>
              <th>{{ data.orden_id }}</th>

              <th>{{ data.fecha | date: 'dd/MM/yyyy' }}</th>
              <td>
                {{ data.nombre_cliente }}
              </td>

              <td>{{ data.nombre_vendedor }}</td>
              <td class="text-right">{{ data.total | number: '1.2-2' }}</td>
              <td class="text-right">{{ data.pagado | number: '1.2-2' }}</td>
              <td class="text-right">{{ data.deuda | number: '1.2-2' }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3"></td>
              <td colspan="1">SUBTOTAL</td>
              <td class="text-left">
                {{ totalSum | currency: 'BOB':'symbol-narrow':'1.2-2' }}
              </td>
              <td class="text-left">
                {{ totalPagado | currency: 'BOB':'symbol-narrow':'1.2-2' }}
              </td>
              <td class="text-left">
                {{ totalDeuda | currency: 'BOB':'symbol-narrow':'1.2-2' }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>
